import React from 'react';

import { S3_MP4_URL } from '../../../../constants';

import styles from '../../CircleBlock.scss';

const ThirdCircle = () => (
  <div id="circle-3" className={styles.circleBlock}>
    <video
      id="third-circle-video"
      autoPlay={true}
      preload="auto"
      loop={true}
      muted={true}
      playsInline={true}
      className={styles.circle}
    >
      <source src={`${S3_MP4_URL}circle_planet.mp4`} type="video/mp4" />
    </video>
  </div>
);

export default ThirdCircle;
